module.exports = __webpack_public_path__ + "5fd4c338c1a1b1eeeb2c7b0a0967773d.woff";